"use strict";
/**
 * Polymarket Market Fetcher
 * Handles fetching market data from Polymarket API
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPolymarketEvents = fetchPolymarketEvents;
exports.fetchPolymarketEventMarkets = fetchPolymarketEventMarkets;
const state_1 = require("../state");
const polymarketApi = __importStar(require("../polymarket-api"));
const cache_1 = require("./cache");
const constants_1 = require("./constants");
/**
 * Fetch events from Polymarket API
 */
async function fetchPolymarketEvents(sportSeriesId, tagSlug) {
    try {
        console.log(`Fetching events from Polymarket API for sport series: ${sportSeriesId}...`);
        const events = await polymarketApi.getEvents({
            sportSeriesId,
            active: true,
            limit: 200,
            sortByDate: true,
            tagSlug,
        });
        // Store in Polymarket cache
        (0, cache_1.setPolymarketEventCache)(events);
        // Convert to DisplayEvent format
        const displayEvents = events.map(polymarketApi.polymarketEventToDisplayEvent);
        console.log(`Fetched ${events.length} Polymarket events, converted to ${displayEvents.length} display events`);
        return displayEvents;
    }
    catch (error) {
        const errorMessage = error instanceof polymarketApi.PolymarketApiError
            ? `Failed to fetch Polymarket events: ${error.message}`
            : "Failed to fetch Polymarket events.";
        (0, state_1.updateState)({
            isLoadingMarkets: false,
            errorMessage,
        });
        throw error;
    }
}
/**
 * Fetch markets for a Polymarket event from cache
 */
async function fetchPolymarketEventMarkets(eventId) {
    console.log(`Looking up Polymarket event in cache: ${eventId}...`);
    // Check if Polymarket cache is fresh
    if (Date.now() - (0, cache_1.getPolymarketCacheTimestamp)() >= constants_1.MARKET_CACHE_DURATION) {
        throw new Error("Polymarket event cache expired. Please refresh the events list and try again.");
    }
    // Find event in cache
    const polymarketEventCache = (0, cache_1.getPolymarketEventCache)();
    const event = polymarketEventCache.find((e) => e.id === eventId);
    if (!event) {
        throw new Error(`Event ${eventId} not found in cache. Please refresh the events list and try again.`);
    }
    if (!event.markets || event.markets.length === 0) {
        throw new Error(`No markets found for event: ${event.title}`);
    }
    // Convert event markets to Market format
    const convertedMarkets = event.markets.map((market) => polymarketApi.polymarketEventMarketToMarket(market, {
        title: event.title,
    }));
    console.log(`Found ${convertedMarkets.length} markets for Polymarket event: ${event.title}`);
    return convertedMarkets;
}
